// src/pages/TermsPage.tsx

import { StaticPageLayout } from '@/components/StaticPageLayout';

export const TermsPage = () => {
  return (
    <StaticPageLayout title="sidepocket 利用規約">
      <p className="text-gray-700 leading-relaxed mb-6">
        この利用規約（以下、「本規約」といいます。）は、sidepocket運営事務局（以下、「当方」といいます。）がこのウェブサイト上で提供するサービス「sidepocket」（以下、「本サービス」といいます。）の利用条件を定めるものです。登録ユーザーの皆さま（以下、「ユーザー」といいます。）には、本規約に従って、本サービスをご利用いただきます。
      </p>

      <Section title="第1条（適用）">
        <p>
          本規約は、ユーザーと当方との間の本サービスの利用に関わる一切の関係に適用されるものとします。
        </p>
      </Section>

      <Section title="第2条（利用登録）">
        <ol className="list-decimal list-inside space-y-3">
          <li>
            登録希望者が当方の定める方法によって利用登録を申請し、当方がこれを承認することによって、利用登録が完了するものとします。
          </li>
          <li>
            当方は、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあり、その理由については一切の開示義務を負わないものとします。
            <ol className="list-[lower-alpha] list-inside pl-4 mt-2 space-y-1">
              <li>利用登録の申請に際して虚偽の事項を届け出た場合</li>
              <li>本規約に違反したことがある者からの申請である場合</li>
              <li>その他、当方が利用登録を相当でないと判断した場合</li>
            </ol>
          </li>
        </ol>
      </Section>

      <Section title="第3条（ユーザーIDおよびパスワードの管理）">
        <ol className="list-decimal list-inside space-y-3">
          <li>
            ユーザーは、自己の責任において、本サービスのユーザーIDおよびパスワードを管理するものとします。
          </li>
          <li>
            ユーザーは、いかなる場合にも、ユーザーIDおよびパスワードを第三者に譲渡または貸与することはできません。当方は、ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には、そのユーザーIDを登録しているユーザー自身による利用とみなします。
          </li>
        </ol>
      </Section>

      <Section title="第4条（利用料金および支払方法）">
        <ol className="list-decimal list-inside space-y-3">
          <li>
            本サービスの一部機能は有料で提供する場合があります。
          </li>
          <li>
            有料サービスの料金、支払方法、解約手続きその他の条件については、当方が別途定め、本サービスまたは関連サイト上に表示するものとします。
          </li>
          <li>
            ユーザーが有料サービスを利用開始した後は、法令で定められる場合を除き、料金の返金は行いません。
          </li>
        </ol>
      </Section>

      <Section title="第5条（禁止事項）">
        <p className="mb-3">ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。</p>
        <ol className="list-decimal list-inside space-y-2">
          <li>法令または公序良俗に違反する行為</li>
          <li>犯罪行為に関連する行為</li>
          <li>当方のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為</li>
          <li>当方のサービスの運営を妨害するおそれのある行為</li>
          <li>他のユーザーに関する個人情報等を収集または蓄積する行為</li>
          <li>他のユーザーに成りすます行為</li>
          <li>当方のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為</li>
          <li>その他、当方が不適切と判断する行為</li>
        </ol>
      </Section>

      <Section title="第6条（本サービスの提供の停止等）">
        <ol className="list-decimal list-inside space-y-3">
          <li>
            当方は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。
            <ol className="list-[lower-alpha] list-inside pl-4 mt-2 space-y-1">
              <li>本サービスにかかるコンピュータシステムの保守点検または更新を行う場合</li>
              <li>地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合</li>
              <li>コンピュータまたは通信回線等が事故により停止した場合</li>
              <li>その他、当方が本サービスの提供が困難と判断した場合</li>
            </ol>
          </li>
          <li>
            当方は、本サービスの提供の停止または中断により、ユーザーまたは第三者が被ったいかなる不利益または損害について、理由を問わず一切の責任を負わないものとします。
          </li>
        </ol>
      </Section>

      <Section title="第7条（著作権）">
        <p>
          本サービスにおいてユーザーが投稿した文章、画像等の著作権は、当該ユーザーその他既存の権利者に留保されるものとします。ただし、当方は、本サービスの提供・改善およびサービスの周知・広報に必要な範囲に限定して、ユーザーが投稿した情報を無償で利用できるものとし、ユーザーはこれに同意するものとします。
        </p>
      </Section>

      <Section title="第8条（免責事項）">
        <ol className="list-decimal list-inside space-y-3">
          <li>
            当方の債務不履行責任は、当方の故意または重過失によらない場合には免責されるものとします。
          </li>
          <li>
            当方は、何らかの理由によって責任を負う場合にも、通常生じうる損害の範囲内においてのみ賠償の責任を負うものとします。
          </li>
          <li>
            当方は、本サービスに含まれる情報の正確性、最新性、有用性等についていかなる保証も行いません。
          </li>
          <li>
            当方は、本サービスに関して、ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。
          </li>
        </ol>
      </Section>

      <Section title="第9条（サービス内容の変更等）">
        <p>
          当方は、ユーザーに通知することなく、本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし、これによってユーザーに生じた損害について一切の責任を負いません。
        </p>
      </Section>

      <Section title="第10条（利用規約の変更）">
        <p>
          当方は、必要と判断した場合には、本サービス上での掲示その他当方が適切と判断する方法により、事前に通知することなく本規約を変更することができます。変更後の規約は、当方が定める方法により公表した時点から効力を生じるものとします。
        </p>
      </Section>

      <Section title="第11条（退会）">
        <p>
          ユーザーは、当方の定める手続きに従い、いつでも本サービスから退会することができます。
        </p>
      </Section>

      <Section title="第12条（外部サービスの利用）">
        <p>
          本サービスは、Firebase AuthenticationやGoogle Calendar API等の外部サービスを利用しています。ユーザーは、これらのサービスを利用するにあたり、当該外部サービスの利用規約およびプライバシーポリシー等に同意する必要があります。
        </p>
      </Section>

      <Section title="第13条（広告の表示）">
        <p>
          本サービスには、当方または第三者の広告が表示される場合があります。Freeプランをご利用のユーザーには、Google Adsense等の第三者配信広告が表示されます。広告の表示に関する詳細は、
          <a href="/privacy" className="text-blue-600 hover:underline">プライバシーポリシー</a>
          をご確認ください。
        </p>
      </Section>

      <Section title="第14条（準拠法・裁判管轄）">
        <ol className="list-decimal list-inside space-y-3">
          <li>
            本規約の解釈にあたっては、日本法を準拠法とします。
          </li>
          <li>
            本サービスに関して紛争が生じた場合には、当方の本店所在地を管轄する裁判所を専属的合意管轄とします。
          </li>
        </ol>
      </Section>

      <div className="mt-10 pt-6 border-t border-gray-200">
        <p className="text-gray-600">以上</p>
        <p className="text-gray-600">改定日：2025年7月31日</p>
      </div>
    </StaticPageLayout>
  );
};

// セクションコンポーネント
const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <section className="mt-10">
    <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
      {title}
    </h2>
    <div className="text-gray-700 leading-relaxed pl-4">
      {children}
    </div>
  </section>
);
